import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from "../design/app";
import { IAppConfig } from '../core/models/app-config.model';
import { IApiResponse } from '../core/models/api-response.model';
import { Presenter } from '../models/presenter';

@Injectable()
export class FacilitatorService {
    private appConfig:any;
  constructor(private http: HttpClient) {
    this.appConfig = AppConfig;
    }

    searchFacilitator(selectionSearch): Observable<Presenter[]> {
        const baseUrl = this.appConfig.facilitator.baseUrl;
        const searchFacilitatorUrl =  this.appConfig.facilitator.searchFacilitator;
        const apiUrl = `${baseUrl + searchFacilitatorUrl}`;
        return this.http.post<IApiResponse<Presenter[]>>(apiUrl, selectionSearch).pipe(
            map((res) => {
                if (res.Data) {
                    return res.Data;
                }
                return null;
            })
        );
    }

    saveFacilitator(savedSelection): Observable<boolean>{
        const baseUrl = this.appConfig.facilitator.baseUrl;
        const saveFacilitatorUrl =  this.appConfig.facilitator.saveFacilitator;
        const apiUrl = `${baseUrl + saveFacilitatorUrl}`;
        return this.http.post<IApiResponse<string>>(apiUrl, savedSelection).pipe(
            map((res) => {
                if (res.Success) {
                    return res.Success;
                }
                return null;
            })
        );
    }

    updateListBasedOnCountry(countryId, masterData, listType) {
        let modifiedFunctions = [];
        let list = masterData[listType] ? masterData[listType] : [];
        if (countryId == 23 || countryId == 259 || countryId == 265) {
            modifiedFunctions = list.filter(data => data.IsMDR === true);
            list = JSON.parse(JSON.stringify(modifiedFunctions));
        } else {
            modifiedFunctions = list.filter(data => data.IsMDR === false && data.SectorName !== "N/A, hosting Member Firm does not use these designations"
                && data.Name !== "N/A, hosting Member Firm does not use these designations" && data.ServiceAreaName !== "N/A, hosting Member Firm does not use these designations");
                                                                                         
            list = JSON.parse(JSON.stringify(modifiedFunctions));
        }
        return list;
    }

    onDropdownSelect(id, masterData, listType, parentId) {
        let list = masterData[listType] ? masterData[listType] : [];
        let modifiedCityList = [];
        if (Number(id)) {
            modifiedCityList = list.filter(data => data[parentId] == id);
            list = JSON.parse(JSON.stringify(modifiedCityList));
        }
        return list;
    }

    getExportData(payload): Observable<Uint8Array> {
        const baseUrl = this.appConfig.facilitator.baseUrl;
        const getExportDataUrl =  this.appConfig.facilitator.getExportData;
        const apiUrl = `${baseUrl + getExportDataUrl}`;
        return this.http.post(apiUrl, payload, { responseType: 'arraybuffer' }).pipe(
            map(response => {
                return new Uint8Array(response);
            }),
        );
    }
}
